import { render, staticRenderFns } from "./NotificationBatchVolunteers.vue?vue&type=template&id=610f6fa0&"
import script from "./NotificationBatchVolunteers.vue?vue&type=script&lang=js&"
export * from "./NotificationBatchVolunteers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports